import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { NoticePopup } from '@/store/API/PopupAcknowledgements'
import { parseContent } from '../utils/fmlToken'
import QNoticesAcknowledgeButtons from './QNoticesAcknowledgeButtons.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageCardWithoutFml',
  props: {
    message: null,
    hideControls: { type: Boolean, default: false },
    color: { default: 'q_messages_3' },
    loading: { type: Boolean, default: false },
    elevation: null
  },
  emits: ["acknowledgeAndClose", "snoozeAndClose", "acknowledge", "close"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'acknowledgeAndClose'): void;
	(e: 'snoozeAndClose'): void;
	(e: 'acknowledge'): void;
	(e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { message: NoticePopup, hideControls: boolean, color: string, loading: boolean, elevation?: number | string }





const parsedContent = computed(() => parseContent(props.message.content))

const doShowCloseButton = ref(false)

const acknowledgeAndShowCloseButton = () => {
	doShowCloseButton.value = true
	emit('acknowledge')
}

return { __sfc: true,props, emit, parsedContent, doShowCloseButton, acknowledgeAndShowCloseButton, QNoticesAcknowledgeButtons }
}

})